import { render, staticRenderFns } from "./addCollectionAccount.vue?vue&type=template&id=141cbdfb&scoped=true"
import script from "./addCollectionAccount.vue?vue&type=script&lang=js"
export * from "./addCollectionAccount.vue?vue&type=script&lang=js"
import style0 from "./addCollectionAccount.vue?vue&type=style&index=0&id=141cbdfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141cbdfb",
  null
  
)

export default component.exports